import { ContextNames } from '../components/BoostV2/Admins/AdminToggleSwitch';

export enum CasingType {
    CASING_SENTENCE = 'CASING_SENTENCE',
    CASING_UPPERCASE = 'CASING_UPPERCASE',
    CASING_LOWERCASE = 'CASING_LOWERCASE',
    CASING_START = 'CASING_START',
}

export const convertToCasing = (value: string, casing: CasingType): string => {
    if (value) {
        switch (casing) {
            case CasingType.CASING_SENTENCE: {
                return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
            }
            case CasingType.CASING_UPPERCASE: {
                return value.toUpperCase();
            }
            case CasingType.CASING_LOWERCASE: {
                return value.toLowerCase();
            }
            case CasingType.CASING_START: {
                const values = value.toLowerCase().split(' ');

                for (let i = 0; i < values.length; i += 1) {
                    values[i] = values[i].charAt(0).toUpperCase() + values[i].substring(1);
                }
                return values.join(' ');
            }
            default:
                return value;
        }
    }

    return value;
};

export const truncateString = (str: string, wantedLength: number): string => {
    return str.length > wantedLength ? `${str.slice(0, wantedLength - 2)}...` : str;
};

// no /g flag: a global regex is stateful (lastIndex persists across .test()
// calls), which makes repeated validations of the same value alternate pass/fail
export const phoneRegex = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

// zero-width space/non-joiner/joiner, word joiner, and BOM - invisible characters
// that ride along in pasted text, render as nothing, survive .trim(), and fail
// validation (e.g. an email pasted with a trailing U+2060 fails Yup's .email())
export const stripInvisibleCharacters = (value: string): string =>
    value?.replace(/[\u200B-\u200D\u2060\uFEFF]/g, '') ?? value;

export const getCityNamesString = (cities: string[]): string => {
    if (!cities || cities.length <= 0) {
        return '';
    }
    const { length } = cities;
    if (length === 1) {
        return `${cities[0]} area`;
    }
    return `${cities.join(', ').replace(/, ((?:.(?!, ))+)$/, ' or $1')} areas`;
};

export const getNameInitials = (fullName: string | null): string => {
    if (!fullName) {
        return '';
    }

    const names = fullName.split(' ');
    const initials = names.map((n) => n.charAt(0));

    let initialsString = '';
    if (initials.length > 0) {
        const first = initials.shift(); // get first initial
        initialsString += first;
    }
    if (initials.length > 0) {
        const last = initials.pop(); // get last initial
        initialsString += last;
    }

    return initialsString.toUpperCase();
};

export const formatAddress = ({
    city,
    state,
    zip,
}: {
    city?: string;
    state?: string;
    zip?: string;
}): string => {
    return [city, [state, zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
};

export const formatPhoneNumber = (phone: string): string => {
    const digits = phone.replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
    return [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 10)].filter(Boolean).join('-');
};

export const rocket = '🚀';
